import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import moment from 'moment';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-expense-history',
  standalone: true,
  imports: [DataTablesModule, CommonModule, RouterModule, NgbDatepickerModule, LoaderComponent, FormsModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './expense-history.component.html',
  styleUrl: './expense-history.component.scss'
})
export class ExpenseHistoryComponent {
  isDisabled: boolean = false;
  TableDatas = [] as any;
  TableDatasMain = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    ESS_ExpenseReportRequestId: null,
    TripMasterId: null,
    SelectType: 'RD',
    EmpMasterId: null,
    TravelType: 'Local',
    ESS_ExpenseRequestMainId: null,
    ESS_ExpenseRequestDetailsId: null,
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    Type: 'All',
    ApprovalStatus: 'All'
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    private session: SessionService,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.Filter.EmpMasterId = session.GetUserDetails().UserId;
    if (window.location.pathname.includes('expense/history')) {
      this.Filter.TravelType = 'Local';
    } else if (window.location.pathname.includes('outstation/history')) {
      this.Filter.TravelType = 'Outstation';
    }
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if ((moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY')))) {
        this.GetDailyAttendanceInOutHistory();
      } else {
        this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetDailyAttendanceInOutHistory() {
    this.isDisabled = true;
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    this.expense.ESS_ExpenseRequest_SelectGet(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatasMain = response.Table;
          // this.TableDatasMain.forEach((element: any) => {
          //   if (element.Attachment != null && element.Attachment != '') {
          //     element.Attachment = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ExpenseFolder + '/' + element.Attachment
          //   }
          // });
          this.FilterData();
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();

          this.GetDailyAttendanceInOutHistory();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }

  FilterData() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });

    if (this.Filter.Type == 'All') {
      this.TableDatas = this.TableDatasMain;
    } else if (this.Filter.Type == 'Category') {
      this.TableDatas = this.TableDatasMain.filter((e: any) => e.ESS_ExpenseCategoryMasterId != null && e.ESS_ExpenseCategoryMasterId != '' && e.ESS_ExpenseCategoryMasterId > 0);
    } else if (this.Filter.Type == 'Vehicle') {
      this.TableDatas = this.TableDatasMain.filter((e: any) => e.ESS_VehicleMasterId != null && e.ESS_VehicleMasterId != '' && e.ESS_VehicleMasterId > 0);
    } else {
      this.Clear();
    }
  }

  Clear() {
    this.TableDatas = [];
    this.TableDatasMain = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  Cancel() {
    if (this.Filter.TravelType == 'Local') {
      this.router.navigate(['/request/expense/']);
    } else if (this.Filter.TravelType == 'Outstation') {
      this.router.navigate(['/request/outstation/']);
    }
  }

}
